"use strict";

import $ from "jquery";
window.$ = window.jQuery = $;
import 'slick-carousel'

export class HPPhotoGallery {
  constructor() {
    console.log("PhotoGallery module");

    (function( $ ) {
        // Use $ as usual here, e.g.:
        $(".js-photo__gallery").slick({
            mobileFirst: true,
            infinite: true,
            slidesToShow: 2,
            arrows: true,
            dots: false,
            autoplay: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 5
                }
              }
            ]
        });
    })( jQuery );
  }
}
